import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FactoryMachineService {
  private readonly http = inject(HttpClient);
  private readonly endPoint = environment.API_ENDPOINT + `factory-machine/`;
  getAllWithFilters(options?: {
    page?: number;
    take?: number;
    factory?: string;
    searchTerm?: string;
    name?: string;
    factoryMachineGroup?: string;
    hideList?: boolean;
  }) {
    return this.http.get(
      `${this.endPoint}?page=${options?.page ?? 1}&take=${options?.take ?? 0}&searchTerm=${
        options?.searchTerm || ''
      }&factory=${options?.factory || ''}&name=${options.name || ''}&factoryMachineGroup=${
        options.factoryMachineGroup || ''
      }&hideList=${options.hideList || false}`
    );
  }
  getById(id: string) {
    return this.http.get(this.endPoint + id);
  }
  create(payload: any): Observable<any> {
    return this.http.post(this.endPoint, payload);
  }
  createMany(payload: any[]): Observable<any> {
    return this.http.post(this.endPoint + 'bulk-create', payload);
  }
  update(id: string, payload: any): Observable<any> {
    return this.http.patch(this.endPoint + id, payload);
  }
  delete(id: string): Observable<any> {
    return this.http.delete(this.endPoint + id);
  }
}
